import { gql } from "@apollo/client";

export const GET_USER_PINNED_CLIPS = gql`
  query GetUserPinnedlips($userId: String!) {
    getUser(_id: $userId) {
      pinnedClips {
        id
        internalId
        thumbnailUrl(style: STANDARD)
        isPinned
        title
        type
        shareId
        createdAt
        views
        previewUrl
        user {
          _id
          username
          avatar
        }
        saved {
          savedBy
          savedAt
        }
        developer {
          id
          name
        }
      }
    }
  }
`;
